import React from 'react';
import { REGIONS_DATA } from '../utils/regionData';
import MultiSelectDropdown from './MultiSelectDropdown';

const FiltersBar = ({ 
    availableRegions = [],
    availableCountries = [],
    selectedRegions = [], 
    onRegionsChange, 
    selectedCountries = [], 
    onCountriesChange
}) => {
    
    const getAvailableCountries = () => {
        let regionCountries = [];
        if (selectedRegions.length === 0) {
            const specificAvail = availableRegions.filter(r => r.toLowerCase() !== 'global');
            
            // If reports only have 'Global', don't populate all countries
            if (availableRegions.length > 0 && specificAvail.length === 0) {
                return [];
            }

            regionCountries = REGIONS_DATA.reduce((acc, region) => {
                if (region.id === 'global') return acc;
                
                if (availableRegions.length > 0) {
                     const isAvail = availableRegions.some(a => a.toLowerCase() === region.name.toLowerCase() || a.toLowerCase().includes(region.name.toLowerCase()));
                     if (!isAvail) return acc;
                }
                return [...acc, ...region.countries];
            }, []);
        } else {
            const specificRegions = selectedRegions.filter(r => r.toLowerCase() !== 'global');
            if (specificRegions.length === 0) {
                return [];
            }
            regionCountries = specificRegions.reduce((acc, regionName) => {
                const regionObj = REGIONS_DATA.find(r => r.name.toLowerCase() === regionName.toLowerCase());
                return regionObj ? [...acc, ...regionObj.countries] : acc;
            }, []);
        }

        // Intersect REGION countries with AVAILABLE reports countries
        if (availableCountries.length > 0) {
            const availLower = availableCountries.map(c => c.toLowerCase().trim());
            return regionCountries.filter(c => availLower.includes(c.toLowerCase().trim()));
        }
        
        return regionCountries;
    };

    const finalCountriesList = [...new Set(getAvailableCountries())].sort();
    
        // If availableRegions is empty, we show all regions to maintain UI structure
        const regionOptions = availableRegions.length > 0
            ? REGIONS_DATA
                .filter(r => availableRegions.some(a => a.toLowerCase() === r.name.toLowerCase() || a.toLowerCase().includes(r.name.toLowerCase())))
                .map(r => ({ id: r.id, name: r.name }))
            : REGIONS_DATA.map(r => ({ id: r.id, name: r.name }));


    const handleRegionToggle = (regionName) => {
        const newRegions = selectedRegions.includes(regionName)
            ? selectedRegions.filter(r => r !== regionName)
            : [...selectedRegions, regionName];
        onRegionsChange(newRegions);
    };

    const handleCountryToggle = (countryName) => {
        const newCountries = selectedCountries.includes(countryName)
            ? selectedCountries.filter(c => c !== countryName)
            : [...selectedCountries, countryName];
        onCountriesChange(newCountries);
    };

    return (
        <div className="d-flex gap-2 align-items-center">
            <MultiSelectDropdown 
                label="Regions" 
                options={regionOptions}
                selected={selectedRegions}
                onSelect={handleRegionToggle}
                onClearAll={() => onRegionsChange([])}
                placeholder="Search Regions..."
            />

            <MultiSelectDropdown 
                label="Countries" 
                options={finalCountriesList}
                selected={selectedCountries}
                onSelect={handleCountryToggle}
                onClearAll={() => onCountriesChange([])}
                placeholder="Search Countries..."
                alignRight={true}
                disabled={(selectedRegions.length > 0 && selectedRegions.every(r => r.toLowerCase() === 'global')) || (availableRegions.length === 1 && availableRegions[0].toLowerCase() === 'global') || finalCountriesList.length === 0}
            />
        </div>
    );
};

export default FiltersBar;
